<template>
  <div
    class="vue-splitter-container clearfix"
    :style="cursor"
    @mouseup="onMouseUp"
    @mousemove="onMouseMove($event)"
  >
    <div :class="['splitter-pane splitter-paneL',splitSet.split]" :style="splitType">
      <slot name="paneL"></slot>
    </div>
    <div v-if="draggable" :class="classes" :style="resizeType" @mousedown="onMouseDown" @click="onClick"></div>
    <div
      :class="[
      'splitter-pane splitter-paneR', splitSet.split
    ]"
      :style="{[type]: 100 - percent + '%' }"
    >
      <slot name="paneR"></slot>
    </div>
    <div v-show="active" class="vue-splitter-container-mask"></div>
  </div>
</template>

<script>
export default {
  name: "splitPane",
  props: {
    splitSet: {
      type: Object,
      default: () => {
        return {
          minPercent: 0,
          maxPercent:40,
          defaultPercent: 20,
          split: "vertical"
        };
      },
      require: true
    },
    draggable: { // 新增的属性
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      active: false,
      hasMoved: false,
      percent: 20
    };
  },
  computed: {
    classes() {
      return ["splitter-pane-resizer", this.splitSet?.split].join(" ");
    },
    type() {
      return this.splitSet?.split === "vertical" ? "width" : "height";
    },
    cursor() {
      if (this.draggable) { // 如果允许拖动
        return this.active
          ? this.splitSet?.split === "vertical"
            ? { cursor: "col-resize" }
            : { cursor: "row-resize" }
          : { cursor: "default" };
      } else { // 如果不允许拖动
        return { cursor: "default" };
      }
    },
    splitType() {
      return {
        [this.splitSet?.split === "vertical" ? "width" : "height"]:
          this.percent + "%"
      };
    },
    resizeType() {
      return {
        [this.splitSet?.split === "vertical" ? "left" : "top"]:
          this.percent + "%"
      };
    }
  },
  watch: {
    "splitSet.defaultPercent": {
      handler(val) {
        this.percent = val;
      },
      immediate: true
    }
  },
  methods: {
    onClick() {
      if (!this.hasMoved && this.draggable) {
        this.percent = 50;
        this.$emit("resize", this.percent);
      }
    },
    onMouseDown() {
      if (this.draggable) {
        this.active = true;
        this.hasMoved = false;
      }
    },
    onMouseUp() {
      this.active = false;
    },
    onMouseMove(e) {
      if (!this.draggable) return;
      if (e.buttons === 0 || e.which === 0) {
        this.active = false;
      }

      if (this.active) {
        let offset = 0;
        let target = e.currentTarget;
        if (this.splitSet?.split === "vertical") {
          while (target) {
            offset += target.offsetLeft;
            target = target.offsetParent;
          }
        } else {
          while (target) {
            offset += target.offsetTop;
            target = target.offsetParent;
          }
        }

        const currentPage =
          this.splitSet?.split === "vertical" ? e.pageX : e.pageY;
        const targetOffset =
          this.splitSet?.split === "vertical"
            ? e.currentTarget.offsetWidth
            : e.currentTarget.offsetHeight;
        const percents =
          Math.floor(((currentPage - offset) / targetOffset) * 10000) / 100;

        if (
          percents > this.splitSet?.minPercent &&
          percents < this.splitSet?.maxPercent
        ) {
          this.percent = percents;
        }

        this.$emit("resize", this.percent);

        this.hasMoved = true;
      }
    }
  },
};
</script>

<style>
@import "./iconfont/iconfont.css";
.clearfix::after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}

.vue-splitter-container {
  height: 100%;
  position: relative;
}

.vue-splitter-container-mask {
  z-index: 9999;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.splitter-pane.vertical.splitter-paneL {
  position: absolute;
  left: 0;
  height: 100%;
}

.splitter-pane.vertical.splitter-paneR {
  position: absolute;
  background: #fff;
  right: 0;
  height: 100%;
  /* padding-left: 16px; */
}

.splitter-pane.horizontal.splitter-paneL {
  position: absolute;
  top: 0;
  width: 100%;
}

.splitter-pane.horizontal.splitter-paneR {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding-top: 3px;
}
.splitter-pane-resizer {
  box-sizing: border-box;
  background: #000;
  position: absolute;
  opacity: 0.2;
  z-index: 1;
  background-clip: padding;
  background-clip: padding-box;
}

.splitter-pane-resizer.horizontal {
  height: 6px;
  width: 100%;
  background: #e5e6eb;
  cursor: row-resize;
}

.splitter-pane-resizer.horizontal:before {
  content: "\eda3";
  font-family: "iconfont";
  font-size: 13px;
  color: #000;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.splitter-pane-resizer.vertical {
  width: 6px;
  height: 100%;
  background: #e5e6eb;
  cursor: col-resize;
}

.splitter-pane-resizer.vertical:before {
  content: "\e647";
  font-family: "iconfont";
  font-size: 13px;
  color: #000;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>